export default __webpack_public_path__ + "static/james-governor-cd0fdc873faddce9bd5758711cc4182c.png";